export const basePath = "/contractor/onboarding";
